import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SearchTable from '@/components/SearchTable.vue';
import _ from 'lodash';
import VueMarkdown from 'vue-markdown';
import BackButton from '@/components/BackButton.vue';
const archetypeModule = namespace('feats');
let CharactersFeats = class CharactersFeats extends Vue {
    constructor() {
        super(...arguments);
        this.initialSearch = '';
        this.tableType = 'Feats';
    }
    created() {
        this.fetchFeats();
        this.initialSearch = this.$route.query.search;
    }
    get items() {
        const page = this.isInHandbook ? 'phb' : 'characters';
        return _(this.feats)
            .filter(({ contentType }) => !this.isInHandbook || contentType === 'Core')
            .map(feat => ({
            ...feat,
            id: feat.name,
            isExpandable: feat.text
        })).value();
    }
    get headers() {
        return [
            {
                text: 'Name',
                value: 'name'
            },
            {
                text: 'Ability Score Increase',
                value: 'attributesIncreased',
                render: (value) => _.upperFirst(value ? value.join(' or ') : '-'),
                filterChoices: ['Strength', 'Dexterity', 'Constitution', 'Intelligence', 'Wisdom', 'Charisma'],
                filterFunction: ({ attributesIncreased }, filterValue) => _.includes(attributesIncreased, filterValue)
            },
            {
                text: 'Prerequisite',
                value: 'prerequisite'
            },
            {
                text: 'Source',
                value: 'contentSource',
                render: _.startCase,
                filterChoices: ['PHB', 'EC', 'WH'],
                filterFunction: ({ contentSource }, filterValue) => _.startCase(contentSource) === filterValue
            }
        ];
    }
};
__decorate([
    archetypeModule.State
], CharactersFeats.prototype, "feats", void 0);
__decorate([
    archetypeModule.Action
], CharactersFeats.prototype, "fetchFeats", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], CharactersFeats.prototype, "isInHandbook", void 0);
CharactersFeats = __decorate([
    Component({
        components: {
            SearchTable,
            BackButton,
            VueMarkdown
        }
    })
], CharactersFeats);
export default CharactersFeats;
